function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SUPPORT_PAGE_LINK } from "constants/links";
import { withGenericConfig } from "/contexts/generic-config-context";
import SlimLogos from "segments/desktop/logos/layouts/slim-logos/slim-logos-component";
import PictureComponent from "/components/core/picture/picture-component";
import Title from "segments/desktop/core-components/title/title";
import CustomerQuotes from "constants/customer-quotes";
const ContactSalesDetails = (props)=>{
    const { benefits, title, titleSize, logosTitle, logos, translate, translateWithParam, isMobileOrTabletBrowser, customerQuoteKey, hideSupportStatement, hideLogos } = props;
    const iconStyle = {
        width: 37,
        height: 37
    };
    const supportLink = `<a href="${SUPPORT_PAGE_LINK}" class="support-paragraph-link" target="_blank">${translate("contactSales.hubspotForm.support_center")}</a>`;
    const supportStatement = translateWithParam("contactSales.hubspotForm.support_statement", supportLink);
    const customerQuote = CustomerQuotes[customerQuoteKey];
    return /*#__PURE__*/ _jsxs("div", {
        className: "contact-sales-details",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "contact-sales-title",
                children: /*#__PURE__*/ _jsx(Title, {
                    title: translate(title),
                    titleSize: titleSize
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "benefits-wrapper",
                children: benefits === null || benefits === void 0 ? void 0 : benefits.map((benefit)=>/*#__PURE__*/ _jsxs("div", {
                        className: "benefit-wrapper",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "benefit-icon-wrapper",
                                children: [
                                    /*#__PURE__*/ _jsx(PictureComponent, {
                                        src: benefit.icon,
                                        specificImageStyle: iconStyle
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "icon-text",
                                        dangerouslySetInnerHTML: {
                                            __html: translate(benefit.title)
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("hr", {
                                className: "benefit-text-divider"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "benefit-text-wrapper",
                                children: translate(benefit.description)
                            })
                        ]
                    }, benefit.key))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "support-paragraph-wrapper",
                children: !hideSupportStatement && /*#__PURE__*/ _jsx("span", {
                    className: "support-paragraph-text",
                    dangerouslySetInnerHTML: {
                        __html: supportStatement
                    }
                })
            }),
            customerQuote && /*#__PURE__*/ _jsxs("div", {
                className: "customer-quote-wrapper",
                children: [
                    /*#__PURE__*/ _jsxs("blockquote", {
                        className: "quote",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "quotationMark",
                                children: "“"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "quoteText",
                                children: `${customerQuote === null || customerQuote === void 0 ? void 0 : customerQuote.quote}”`
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "name-and-job-description",
                        children: `${customerQuote === null || customerQuote === void 0 ? void 0 : customerQuote.name} | ${customerQuote === null || customerQuote === void 0 ? void 0 : customerQuote.jobDescription} | ${customerQuote === null || customerQuote === void 0 ? void 0 : customerQuote.companyName}`
                    })
                ]
            }),
            !hideLogos && /*#__PURE__*/ _jsx(SlimLogos, _object_spread_props(_object_spread({}, logosTitle), {
                logos: logos,
                textAlign: isMobileOrTabletBrowser ? "center" : "left"
            }))
        ]
    });
};
export default withGenericConfig(ContactSalesDetails);
